import React from "react"
import LazyImg from "../lazyimg";

const AppDetails = ({icon, heading, content, imgLeft=false}) => (
    <div className="row flex-center">
        {
            imgLeft &&
            <div className="col-md-2 p-0 order1">
                <LazyImg className="appdetail-img" src={icon} alt={heading} />
            </div>
        }
        <div className="col-md-10 order2">
            <h4 className="text-center">{heading}</h4>
            <p className="text-center">{content}</p>
        </div>
        {
            !imgLeft &&
            <div className="col-md-2 p-0 order1">
                <LazyImg className="appdetail-img" src={icon} alt={heading} />
            </div>
        }
    </div>
)

export default AppDetails